/**
 * Get the head of the string, separated by dot notation
 *
 * @param {string} key
 *
 * @return {string}
 */
export var headOfPath = function (key) {
    var firstIndex = key.indexOf('.');
    if (firstIndex === -1) {
        return key;
    }
    return key.substring(0, firstIndex);
};
//# sourceMappingURL=headOfPath.js.map